module.exports = __webpack_public_path__ + "img/compare-blank.806452cc.png";